var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseSelector',{staticClass:"passengerAmountSelector",attrs:{"title":_vm.title,"options":_vm.options,"selectValue":_vm.selectValue},on:{"selectChangeHandler":_vm.selectChangeHandler}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a3425a3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/select/PassengerAmountSelector.vue
// module id = null
// module chunks = 